// src/store/plugins/vuex-localstorage.js

export function loadPersistedEventsState() {
  const saved = localStorage.getItem("eventsState");
  if (!saved) return {};
  try {
    return JSON.parse(saved);
  } catch (e) {
    console.warn("Failed to parse saved events state:", e);
    return {};
  }
}

export function persistEventsStatePlugin(store) {
  store.subscribe((mutation, state) => {
    if (
      mutation.type.startsWith("events/SET_FILTER") ||
      mutation.type === "events/SET_FILTERS" ||
      mutation.type === "events/SET_VIEW_TYPE" ||
      mutation.type === "events/SET_SEARCH"
    ) {
      const dataToSave = {
        filters: state.events.filters,
        viewType: state.events.viewType,
      };
      localStorage.setItem("eventsState", JSON.stringify(dataToSave));
    }
  });
}
